import { baseApi } from '@/services'

type DelayReason = {
  uuid: string
  checklist_group: number
  name: string
}

export const delayReasonsApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    listDelayReasonsByGroup: builder.query<DelayReason[], number>({
      query: (checklistGroupId) => `v2/delay-reasons/?checklist_group=${checklistGroupId}`,
      providesTags: () => ['DelayReasons'],
    }),

    createDelayReason: builder.mutation<DelayReason, Partial<DelayReason>>({
      query: (delayReason) => ({
        method: 'POST',
        url: 'v2/delay-reasons/',
        body: delayReason,
      }),
      invalidatesTags: ['DelayReasons'],
    }),

    deleteDelayReason: builder.mutation<void, string>({
      query: (uuid) => ({
        method: 'DELETE',
        url: `v2/delay-reasons/${uuid}/`,
      }),
      invalidatesTags: ['DelayReasons'],
    }),
  }),
})

export const {
  useListDelayReasonsByGroupQuery,
  useCreateDelayReasonMutation,
  useDeleteDelayReasonMutation,
} = delayReasonsApi
